import { getImage } from "~/utils/utils";
import getWasmPoisTexturesData from "./pois-data";

type TVariant = "textures" | "pois";

interface IItem {
	url: string;
	variant: TVariant;
	// nasobek souradnic textury
	scale?: number;
	// verze pro cache - default verze aplikace
	version?: string;
	image?: HTMLImageElement;
	loadPromise?: Promise<void>;
	canvas?: HTMLCanvasElement;
	ctx?: CanvasRenderingContext2D;
}

const ALL_VARIANTS: Array<IItem> = [{
	url: `/img/textures.png`,
	variant: "textures",
}, {
	url: "/img/icon-textures.webp",
	variant: "pois",
}];

class Textures {
	#variants: Array<IItem>;

	#variantsObj: {[key in TVariant]: IItem};

	constructor() {
		this.#variants = ALL_VARIANTS;
		// @ts-expect-error data
		this.#variantsObj = {};
	}

	load() {
		const allProms: Array<Promise<any>> = [];

		for (const variant of this.#variants) {
			const prom = getImage(`${variant.url}?version=${variant.version || window.appVersion}`);

			this.#variantsObj[variant.variant] = variant;
			variant.loadPromise = prom.then(image => {
				variant.image = image;
				variant.canvas = document.createElement("canvas");
				variant.canvas.width = image.naturalWidth;
				variant.canvas.height = image.naturalHeight;
				variant.ctx = variant.canvas.getContext("2d", { willReadFrequently: true });
				variant.ctx.drawImage(image, 0, 0);
			}, () => {});
		}

		return Promise.all(allProms);
	}

	getPoi(poiId: number): null | ImageData {
		const textureData = getWasmPoisTexturesData(poiId);
		const variantData = this.#variantsObj.pois;

		if (textureData) {
			return variantData.ctx.getImageData(textureData.x, textureData.y, textureData.width, textureData.height);
		}

		return null;
	}

	getPoiScaled(poiId: number, scale = 1): null | ImageData {
		const textureData = getWasmPoisTexturesData(poiId);
		const variantData = this.#variantsObj.pois;

		if (textureData) {
			const newCanvas = document.createElement("canvas");

			// dame pulku
			newCanvas.width = textureData.width * scale;
			newCanvas.height = textureData.height * scale;

			const ctx = newCanvas.getContext("2d");

			ctx.drawImage(variantData.image, textureData.x, textureData.y, textureData.width, textureData.height, 0, 0, newCanvas.width, newCanvas.height);

			return ctx.getImageData(0, 0, newCanvas.width, newCanvas.height);
		}

		return null;
	}
}

export default new Textures();
